import {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import { baseUrl } from "../utils/OtherUtils";
import axios from "axios";
import Cookies from "js-cookie";
import { formatDateToInput } from "../utils/DateUtils";
import { useAuthContext } from "./AuthContext";

const ProfileContext = createContext();

const ProfileProvider = ({ children }) => {
  const { handleNotification, userData, isLoggedIn } = useAuthContext();
  const [userProfile, setUserProfile] = useState({
    name: "",
    dob: "",
    contact: "",
    email: "",
    gender: "",
  });

  // Populate initial state with userData
  useEffect(() => {
    if (userData) {
      setUserProfile((prev) => ({
        ...prev,
        name: userData?.name || "",
        email: userData?.email || "",
        contact: userData?.contact || ""
      }));
    }
  }, [userData]);

  // Function to create a user profile
  const userProfileSave = async () => {
    const url = `${baseUrl}/api/profile/create-profile`;

    try {
      const token = Cookies.get("token");
      const userId = Cookies.get("userId");

      if (!token || !userId) {
        console.error("Missing authentication details.");
        return {
          success: false,
          message: "User is not authenticated. Please log in again.",
        };
      }

      const profilePayload = { ...userProfile, userId };

      const response = await axios.post(url, profilePayload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
   
      if (response?.data?.success) {
        handleNotification(response?.data?.success, response?.data?.message);
        getUserProfile();
      }
    } catch (error) {
      // handleNotification(
      //   false,
      //   // `You can only add products from the ${existingBrand}`
      //   "You cannot have the dupliacte profile details."
      // );
      console.error(
        "Error creating profile:",
        error.response ? error.response.data : error.message
      );
    }
  };

  // Function to get a user profile
  const getUserProfile = useCallback(async () => {
    const url = `${baseUrl}/api/profile/get-profile`;

    try {
      const token = Cookies.get("token");
      const userId = Cookies.get("userId");

      if (!token || !userId) {
        console.error("Missing authentication details.");
      }

      const response = await axios.get(url, {
        params: { userId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.success) {
        // Update the state with only the required fields
        const { name, dob, contact, email, gender } = response?.data?.profile;
        const formattedDob = formatDateToInput(dob);

        setUserProfile((prevState) => ({
          ...prevState,
          name: name || prevState.name,
          dob: formattedDob || prevState.formattedDob,
          contact: contact || prevState.contact,
          email: email || prevState.email,
          gender: gender || prevState.gender,
        }));
      } else {
        console.error("Failed to fetch profile:", response?.data?.message);
      }
    } catch (error) {
      console.error(
        "Error fetching profile:",
        error.response ? error.response.data : error.message
      );
    }
  }, [setUserProfile]);

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");

    if (token && userId) {
      getUserProfile();
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      getUserProfile();
    }
  }, [isLoggedIn]);

  return (
    <ProfileContext.Provider
      value={{ userProfile, setUserProfile, userProfileSave, getUserProfile }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => useContext(ProfileContext);

export default ProfileProvider;
